<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="updateRules"
          ref="ruleForm"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">

              <div class="w-full" v-if="form.Distribuidor">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.distributor')}}
                  <el-form-item prop="Distribuidor">
                    <el-input
                      disabled
                      class="w-full"
                      v-model="form.Distribuidor"
                    />
                  </el-form-item>
                </label>
              </div>

              <div class="w-full" v-if="!form.rol || (form.rol !== 'SuperAdminDistribuidor' && form.rol !== 'AdminDistribuidor' && form.rol !== 'SuperAdministrador')">
                <label class="text-sm font-semibold text-secondary-600 block mb-1" >{{$t('app.client')}} 
                  <el-form-item prop="company">
                    <el-input
                      disabled
                      class="w-full"
                      v-model="form.company"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1"><base-obligatory-icon/>{{$t('configurations.username')}}
                  <el-form-item prop="name">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.name"
                      maxlength='50'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.email')}}
                  <el-form-item prop="email">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.email"
                      maxlength='255'
                      autocomplete="email"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.rol')}}
                <el-form-item prop="rol">
                  <el-input
                    class="w-full"
                    v-model="form.rol"
                    :disabled="true"
                  />
                </el-form-item>
              </label>
            </div>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.tipoAuth"
                prop="tipoAuth"
                :options="tiposAuthForAccessibleSelect"
                :isDisabled="true"
                id-prefix="userprofile"
              >
                <template slot="label">{{$t('configurations.tipo_auth')}}</template>
              </AccessibleElSelect>
            </div>
            <div 
              v-if="form.rol !== 'AdminDistribuidor'"
              class="lg:mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-end mb-4 lg:mb-0 gap-x-2">
                  <el-switch 
                    id="switch-ver-todo-statuses"
                    :aria-label="$t('configurations.ver_todo_statuses')"
                    class="switch-text break-normal both-switch mt-2" 
                    :disabled="
                      !hasPermissionEditVisiblity || 
                      form.rol === 'Usuario' || 
                      form.rol === 'UsuarioConsulta' || 
                      form.rol === 'AdminDistribuidor' || 
                      form.rol === 'SuperAdminDistribuidor' || 
                      form.rol === 'SuperAdministrador'" 
                    v-model="form.verTodoStatuses" 
                  />
                  <label for="switch-ver-todo-statuses" class="flex flex-col text-sm font-semibold text-secondary-600 block">
                    {{$t('configurations.ver_todo_statuses')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  </label>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses"/>
                </div>
                <div class="flex flex-row items-end mb-4 lg:mb-0 gap-x-2">
                  <el-switch 
                    id="switch-ver-todo-companies"
                    :aria-label="$t('configurations.ver_todo_companies')"
                    class="switch-text break-normal both-switch mt-2" 
                    :disabled="
                      !hasPermissionEditVisiblity || 
                      form.rol === 'Usuario' || 
                      form.rol === 'UsuarioConsulta' || 
                      form.rol === 'AdminDistribuidor' || 
                      form.rol === 'SuperAdminDistribuidor' || 
                      form.rol === 'SuperAdministrador'" 
                    v-model="form.verTodoCompanies" 
                  />
                  <label for="switch-ver-todo-companies" class="flex flex-col text-sm font-semibold text-secondary-600 block">
                    {{$t('configurations.ver_todo_companies')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  </label>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies"/>
                </div>
              </div>
            </div>

            <div class="mb-2 lg:mb-6" v-if="hasModuleDobleFactor && form.tipoAuth !== 1 && this.form.tipoAuth !== 3">
              <div class="flex flex-col lg:space-x-4">
                <div class="mb-4 lg:mb-0 w-full">
                  <label for="switch-doble-factor" class="flex flex-col text-sm font-semibold text-secondary-600 block mb-1">
                    {{$t('configurations.client_config_otp')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-doble-factor"
                    :aria-label="$t('configurations.client_config_otp')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.DobleFactor"
                    :disabled="form.BloqueadoDobleFactor"
                    :active-text="$t('app.active')" 
                  />
                </div>
              </div>
            </div>

            <div v-if="form.rol !== 'AdminDistribuidor' && form.rol !== 'SuperAdminDistribuidor' && form.rol !== 'SuperAdministrador' 
              && form.Grupos && form.Grupos.length > 0">
              <div class="mb-4 w-full border-b border-solid border-gray-100 dark:border-darkblue-600"/>

              <div class="mt-4 mb-4">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Mis grupos</h2>
                <el-table
                  ref="grupos"
                  :data="form.Grupos"
                  style="width: 100%"
                  max-height="250"
                  :show-header="form.Grupos && form.Grupos.length > 0">
                  <el-table-column
                    prop="Nombre"
                    label="Nombre"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Tipo"
                    label="Tipo"
                    width="110"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Temporal"
                    label="Vínculo"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span
                        class="rounded-full mr-1 mb-1 pl-1 pr-1 bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-500 border-2 tag-cell"
                        >
                        {{scope.row.Temporal ? "Temporal" : "Permanente"}}
                      </span>
                      <!-- <el-tag v-if="scope.row.Temporal" size="medium">Temporal</el-tag> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div class="mb-6 w-full border-b border-solid border-gray-100 dark:border-darkblue-600"/>

            <!-- <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')" class="mb-4 lg:mb-6 flex flex-row items-center">
              <el-switch @change="onChangeDashboardEnable()" name="testswitch" class="switch-text break-normal" v-model="unableDashboardValue" :active-text="$t('configurations.dashboard_unabled')"></el-switch>
            </div> -->
            <div class="mb-4 lg:mb-6 ">
              <label for="switch-auto-idle-time" class="flex flex-col text-sm font-semibold text-secondary-600 block mb-1">
                {{$t('configurations.auto_idle_time')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
              </label>
              <el-switch 
                id="switch-auto-idle-time"
                :aria-label="$t('configurations.auto_idle_time')"
                @change="onChangeAutoIdleTime()" 
                class="switch-text break-normal both-switch mt-2" 
                v-model="autoIdleTimeValue" 
                :active-text="$t('app.active')" 
              />
              <label for="switch-alerts-time-extended" class="flex flex-col text-sm font-semibold text-secondary-600 block mb-1 mt-4">
                {{$t('configurations.alerts_time_extended')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
              </label>
              <el-switch 
                id="switch-alerts-time-extended"
                :aria-label="$t('configurations.alerts_time_extended')"
                @change="onChangeAlertsTimeExtended()" 
                class="switch-text break-normal both-switch mt-2" 
                v-model="alertsTimeExtended" 
                :active-text="$t('app.active')" 
              />
            </div>
            <div class="lg:mb-4">
              <div class="flex -mx-2 flex-col lg:flex-row" >
                <div class="px-2 w-full mb-2 lg:mb-0 mt-2" v-if="form.tipoAuth !== 1 && this.form.tipoAuth !== 3">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('configurations.change_password')"
                    icon="lock"
                    @click="generatePassword"
                    :loading="isGeneralLoading"
                  />
                </div>
                <div class="px-2 w-full mb-2 lg:mb-0 mt-2 flex flex-row items-center" >
                  <base-button-responsive
                    mode="primary"
                    :text="$t('configurations.reset_views')"
                    icon="retry"
                    @click="resetViews"
                    :loading="isGeneralLoading"
                  />
                  <base-tooltip-icon size="md" :content="tooltipResetViews" class="ml-4"/>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            v-if="form.tipoAuth !== 1 && this.form.tipoAuth !== 3 && hasModuleDobleFactor"
            mode="primary"
            :text="'Restablecer autenticación en dos pasos'"
            icon="retrydoblefactor"
            @click="resetOTPHandler()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <user-generate-password-dialog
        :dialogOpen="showGeneratePassword"
        :email="localUser.IdUsuario"
        @toggleDialog="toggleDialogs"
      />

    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { setUserData } from '@/services/configurations/setUserData'
import { resetVistas } from '@/services/grids/resetVistas'
import { i18n } from '@/i18n'
import UserGeneratePasswordDialog from '@/components/UserGeneratePasswordDialog.vue'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { resetMyOTP } from '@/services/configurations/resetMyOTP'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayout,
    UserGeneratePasswordDialog,
    AccessibleElSelect
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUser: null,
      tiposAuth: TIPOS_AUTH,
      header: {
        title: ' PERFIL DE USUARIO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: null
      },
      intervaloPrueba: null,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      tooltipVerTodoTags: this.$i18n.t('tooltip.ver_todo_tags'),
      tooltipVerTodoStatuses: this.$i18n.t('tooltip.ver_todo_statuses'),
      tooltipVerTodoCompanies: this.$i18n.t('tooltip.ver_todo_companies'),
      tooltipResetViews: this.$i18n.t('tooltip.reset_views'),
      tooltipAutoIdleTime: this.$i18n.t('tooltip.auto_idle_time'),
      autoIdleTimeValue: false,
      alertsTimeExtended: false,
      unableDashboardValue: false,
      form: {
        id: 2,
        name: '',
        email: '',
        company: '',
        Distribuidor: '',
        active: false,
        created_at: '',
        password: '',
        repeat_password: '',
        rol: '',
        verTodoTags: false,
        verTodoStatuses: false,
        verTodoCompanies: false,
        tipoAuth: 0,
        Grupos: [],

        DobleFactor: false,
        BloqueadoDobleFactor: false,
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      updateRules: {
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        email: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        tipoAuth: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    hasPermissionEditVisiblity () {
      return this.$store.getters['auth/hasPermissionEditVisiblity']
    },
    hasModuleDobleFactor () {
      return this.$store.getters['auth/hasModuleDobleFactor']
    },
    tiposAuthForAccessibleSelect () {
      return this.tiposAuth.map(tipo => ({
        id: tipo.id,
        value: tipo.id,
        name: tipo.name
      }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    // console.log(this.$route.params)
    const localUser = this.$store.getters['auth/user']
    this.localUser = localUser
    this.setUser(localUser)
  },
  mounted () {
    this.resetControlFormChanges()
    // this.intervaloPrueba = setInterval(() => {
    //   this.doFeedback('prueba intervalo', 'info')
    // }, 1000)
  },
  beforeDestroy () {
    // clearInterval(this.intervaloPrueba)
  },
  methods: {
    resetOTPHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await resetMyOTP()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onChangeAutoIdleTime () {
      this.$store.dispatch('app/updateautoIdleTime', this.autoIdleTimeValue)
      if (this.autoIdleTimeValue) this.doFeedback('Se cerrará la sesión automáticamente pasados ' + process.env.VUE_APP_IDLE_TIME + ' minutos de inactividad ', 'success')
      else this.doFeedback('La sesión no se cerrará automáticamente por inactividad ', 'success')
    },
    onChangeAlertsTimeExtended () {
      this.$store.dispatch('app/updatealertsTimeExtended', this.alertsTimeExtended)
      if (this.alertsTimeExtended) this.doFeedback('Las alertas se mostrarán en pantalla durante 30 segundos', 'success')
      else this.doFeedback('Las alertas se mostrarán en pantalla durante 3 segundos', 'success')
    },
    onChangeDashboardEnable () {
      this.$store.dispatch('dashboard/setUnableDashboard', this.unableDashboardValue)
      if (this.unableDashboardValue) this.doFeedback('Se cargará el Dashboard desactivado por defecto ', 'success')
      else this.doFeedback('Se cargará el Dashboard de todos los clientes por defecto ', 'success')
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    toggleDialogs: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!this.reg.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    submitForm: function (formName) {
      if (this.$route.params.id !== -1) {
        this.updateUserHandler(formName)
      }
    },
    updateUserHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            Email: this.form.email,
            Nombre: this.form.name,
            DobleFactor: this.form.DobleFactor,
          }
          if (this.form.rol !== 'Usuario' && this.form.rol !== 'UsuarioConsulta') {
            params.VerTodoEstados = this.form.verTodoStatuses
            params.VerTodoEmpresas = this.form.verTodoCompanies
          }
          const response = await setUserData(params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetViews: async function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await resetVistas()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          // Reset all stores
          this.$store.dispatch('notifications/resetCartState')
          this.$store.dispatch('historicalUser/resetCartState')
          this.$store.dispatch('historicalGroup/resetCartState')
          this.$store.dispatch('historicalRule/resetCartState')
          this.$store.dispatch('historicalConfigflow/resetCartState')
          this.$store.dispatch('historicalProceding/resetCartState')
          this.$store.dispatch('historicalOrgprovinces/resetCartState')
          this.$store.dispatch('historicalAPIrequests/resetCartState')
          this.$store.dispatch('historicalClient/resetCartState')
          this.$store.dispatch('historicalCert/resetCartState')
          this.$store.dispatch('historicalCompany/resetCartState')
          this.$store.dispatch('historicalNEO/resetCartState')
          this.$store.dispatch('companies/resetCartState')
            
          this.$store.dispatch('locations/resetCartState')
          this.$store.dispatch('companylocations/resetCartState') 
          this.$store.dispatch('companyothercertificates/resetCartState') 
          this.$store.dispatch('clientlocations/resetCartState')
          
          this.$store.dispatch('certificates/resetCartState')
          this.$store.dispatch('certcompanies/resetCartState')
          this.$store.dispatch('clients/resetCartState')
          this.$store.dispatch('users/resetCartState')
          this.$store.dispatch('userscompanies/resetCartState')
          this.$store.dispatch('userstatus/resetCartState')

          this.$store.dispatch('groups/resetCartState')
          this.$store.dispatch('groupusers/resetCartState')
          this.$store.dispatch('groupcompanies/resetCartState')
          this.$store.dispatch('groupstatus/resetCartState')
          this.$store.dispatch('groupgroups/resetCartState')
          this.$store.dispatch('neogroups/resetCartState')
          this.$store.dispatch('neopresentations/resetCartState')
          this.$store.dispatch('usergroups/resetCartState')
          this.$store.dispatch('trashGroups/resetCartState')
          this.$store.dispatch('trashHistoricalGroups/resetCartState')

          this.$store.dispatch('groupingcompanies/resetCartState')
          this.$store.dispatch('groupinglocations/resetCartState')
          this.$store.dispatch('groupingagencies/resetCartState')

          this.$store.dispatch('rules/resetCartState')
          this.$store.dispatch('rulegroups/resetCartState')

          this.$store.dispatch('configflow/resetCartState')
          this.$store.dispatch('orgprovinces/resetCartState')
          this.$store.dispatch('apirequests/resetCartState')

          this.$store.dispatch('documentmaster/resetCartState')

          this.$store.dispatch('imports/resetCartState')
          this.$store.dispatch('procedings/resetCartState')
          
          // Distribuidor
          this.$store.dispatch('distributors/resetCartState')
          this.$store.dispatch('distributorlocations/resetCartState')
          this.$store.dispatch('historicalDistributor/resetCartState')
          
          this.$store.dispatch('trashUsers/resetCartState')
          this.$store.dispatch('trashHistoricalUsers/resetCartState')
          this.$store.dispatch('trashNotifications/resetCartState')
          this.$store.dispatch('trashHistoricalNotifications/resetCartState')
          this.$store.dispatch('trashCertificates/resetCartState')
          this.$store.dispatch('trashHistoricalCertificates/resetCartState')
          this.$store.dispatch('trashCompanies/resetCartState')
          this.$store.dispatch('trashHistoricalCompanies/resetCartState')

          // Reset all stores persisted
          this.$store.dispatch('notificationsPersisted/resetCartState')
          this.$store.dispatch('historicalUserPersisted/resetCartState')
          this.$store.dispatch('historicalGroupPersisted/resetCartState')
          this.$store.dispatch('historicalRulePersisted/resetCartState')
          this.$store.dispatch('historicalConfigflowPersisted/resetCartState')
          this.$store.dispatch('historicalProcedingPersisted/resetCartState')
          this.$store.dispatch('historicalOrgprovincesPersisted/resetCartState')
          this.$store.dispatch('historicalAPIrequestsPersisted/resetCartState')
          this.$store.dispatch('historicalClientPersisted/resetCartState')
          this.$store.dispatch('historicalCertPersisted/resetCartState')
          this.$store.dispatch('historicalCompanyPersisted/resetCartState')
          this.$store.dispatch('historicalNEOPersisted/resetCartState')
          this.$store.dispatch('companiesPersisted/resetCartState')
            
          this.$store.dispatch('locationsPersisted/resetCartState')
          this.$store.dispatch('companylocationsPersisted/resetCartState') 
          this.$store.dispatch('companyothercertificatesPersisted/resetCartState') 
          this.$store.dispatch('clientlocationsPersisted/resetCartState')
          
          this.$store.dispatch('certificatesPersisted/resetCartState')
          this.$store.dispatch('certcompaniesPersisted/resetCartState')
          this.$store.dispatch('clientsPersisted/resetCartState')
          this.$store.dispatch('usersPersisted/resetCartState')
          this.$store.dispatch('userscompaniesPersisted/resetCartState')
          this.$store.dispatch('userstatusPersisted/resetCartState')

          this.$store.dispatch('groupsPersisted/resetCartState')
          this.$store.dispatch('groupusersPersisted/resetCartState')
          this.$store.dispatch('groupcompaniesPersisted/resetCartState')
          this.$store.dispatch('groupstatusPersisted/resetCartState')
          this.$store.dispatch('groupgroupsPersisted/resetCartState')
          this.$store.dispatch('neogroupsPersisted/resetCartState')
          this.$store.dispatch('neopresentationsPersisted/resetCartState')
          this.$store.dispatch('usergroupsPersisted/resetCartState')
          this.$store.dispatch('trashGroupsPersisted/resetCartState')
          this.$store.dispatch('trashHistoricalGroupsPersisted/resetCartState')

          this.$store.dispatch('groupingcompaniesPersisted/resetCartState')
          this.$store.dispatch('groupinglocationsPersisted/resetCartState')
          this.$store.dispatch('groupingagenciesPersisted/resetCartState')

          this.$store.dispatch('rulesPersisted/resetCartState')
          this.$store.dispatch('rulegroupsPersisted/resetCartState')

          this.$store.dispatch('configflowPersisted/resetCartState')
          this.$store.dispatch('orgprovincesPersisted/resetCartState')
          this.$store.dispatch('apirequestsPersisted/resetCartState')

          this.$store.dispatch('documentmasterPersisted/resetCartState')

          this.$store.dispatch('importsPersisted/resetCartState')

          this.$store.dispatch('documentmasterPersisted/resetCartState')
          this.$store.dispatch('procedingsPersisted/resetCartState')
          
          // Distribuidor
          this.$store.dispatch('distributorsPersisted/resetCartState')
          this.$store.dispatch('distributorlocationsPersisted/resetCartState')
          this.$store.dispatch('historicalDistributorPersisted/resetCartState')
          
          this.$store.dispatch('trashUsersPersisted/resetCartState')
          this.$store.dispatch('trashHistoricalUsersPersisted/resetCartState')
          this.$store.dispatch('trashNotificationsPersisted/resetCartState')
          this.$store.dispatch('trashHistoricalNotificationsPersisted/resetCartState')
          this.$store.dispatch('trashCertificatesPersisted/resetCartState')
          this.$store.dispatch('trashHistoricalCertificatesPersisted/resetCartState')
          this.$store.dispatch('trashCompaniesPersisted/resetCartState')
          this.$store.dispatch('trashHistoricalCompaniesPersisted/resetCartState')

          this.doFeedback('Vistas restablecidas correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setUser: function (user) {
      this.form.id = user.IdUsuario
      this.form.name = user.Usuario
      this.form.email = user.Email
      this.form.company = user.Empresa
      this.form.Distribuidor = user.Distribuidor
      this.form.active = user.active
      this.form.created_at = user.created_at
      this.form.rol = user.Rol
      this.form.verTodoStatuses = user.VerTodoEstados
      this.form.verTodoCompanies = user.VerTodoEmpresas
      this.form.DobleFactor = user.DobleFactor
      this.form.BloqueadoDobleFactor = user.BloqueadoDobleFactor
      this.form.tipoAuth = user.idTipoAutenticacion
      this.form.Grupos = user.Grupos ? user.Grupos : []
      this.autoIdleTimeValue = this.$store.getters['app/autoIdleTime']
      this.alertsTimeExtended = this.$store.getters['app/alertsTimeExtended']
      this.unableDashboardValue = this.$store.getters['dashboard/getUnableDashboard']
      this.resetControlFormChanges()
    },
    generatePassword: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
}
</style>

<style scoped>
.tag-cell {
  border-color: var(--Tag-border-)!important;
}
</style>
